/** @format */

import {Alert, LinearProgress, Grid2 as Grid} from '@mui/material';

import {AccountsKpiName, AccountsCompanyMediaplanType} from 'graphql/generated/types';

import {getGridColumns} from 'helpers/campaignCards';

import {LastCheckType, SensorGroupsType, KpiType, Period} from '../../types';
import {useCampaignCardsData} from '../../hooks/useCampaignCardsData';
import {CampaignCard} from './components/CampaignCard';
import {Root, CardsGrid} from './styles';

export type SensorSeverity = 'red' | 'yellow' | 'gray';

export interface CampaignSensor {
  id: string;
  name: string;
  count: number;
  isCritical: boolean;
  severity?: SensorSeverity;
}

export interface CampaignCardData {
  campaignId: string;
  campaignName: string;
  spent: number;
  spentChartData: {name: string; amount: number}[];
  kpiFact: number;
  kpiPlan?: number;
  kpiDeviation: number;
  kpiName: AccountsKpiName;
  kpiDisplayName: string;
  sensors: CampaignSensor[];
  hasErrors: boolean;
  isGood: boolean;
}

interface CampaignCardsProps {
  lastChecks: ReadonlyArray<LastCheckType>;
  sensorGroups: SensorGroupsType;
  mediaplanType?: AccountsCompanyMediaplanType | null;
  primaryKpi?: KpiType;
  period: Period;
}

export const CampaignCards = ({lastChecks, sensorGroups, mediaplanType, primaryKpi, period}: CampaignCardsProps) => {
  const {visibleCampaigns, loading, error, dailyStats} = useCampaignCardsData({
    period,
    lastChecks,
    sensorGroups,
    mediaplanType,
    primaryKpi,
  });


  if (error) {
    return <Alert severity='error'>{error.message}</Alert>;
  }

  if (loading || !dailyStats) {
    return <LinearProgress style={{flex: 1}} />;
  }

  return (
    <Root>
      <CardsGrid container spacing={0.25}>
        {visibleCampaigns.map(campaign => (
          <Grid
            key={campaign.campaignId}
            size={{
              xs: 12,
              sm: getGridColumns(visibleCampaigns.length),
            }}
          >
            <CampaignCard data={campaign} />
          </Grid>
        ))}
      </CardsGrid>
    </Root>
  );
};
